import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import { searchUsersByNameQuery } from "./queries";
import { QUERY_STATUS } from "constants/constants";

const DybContext = createContext({});

export const useDybContext = () => useContext(DybContext);

export const DybProvider = ({ ...props }) => {
  const [usersByName, setUsersByName] = useState([]);
  const [loadDybList, setLoadDybList] = useState(QUERY_STATUS.INITIAL);

  const searchUsersByName = useCallback(
    async ({ search }) => {
      try {
        setLoadDybList(QUERY_STATUS.LOADING);
        setUsersByName(await searchUsersByNameQuery({ search }));
        setLoadDybList(QUERY_STATUS.SUCCESS);
      } catch (e) {
        console.error("searchUsersByName", e);
        setLoadDybList(QUERY_STATUS.ERROR);
        console.error("Error:", e);
      }
    },
    [setUsersByName]
  );
  const values = useMemo(
    () => ({
      searchUsersByName,
      usersByName,
      loadDybList,
      setLoadDybList,
    }),
    [searchUsersByName, usersByName, loadDybList, setLoadDybList]
  );
  return <DybContext.Provider value={values} {...props} />;
};
